import { render, staticRenderFns } from "./MenuSale.vue?vue&type=template&id=a223e036&scoped=true&"
import script from "./MenuSale.vue?vue&type=script&lang=js&"
export * from "./MenuSale.vue?vue&type=script&lang=js&"
import style0 from "./MenuSale.vue?vue&type=style&index=0&id=a223e036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a223e036",
  null
  
)

export default component.exports